import { render, staticRenderFns } from "./ToApprove.vue?vue&type=template&id=eafff7fa"
import script from "./ToApprove.vue?vue&type=script&lang=js"
export * from "./ToApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports